module.exports = __webpack_public_path__ + "img/StorageBenches.434ad3b3.png";